import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@common';

const ForgotPasswordInfo = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state: { email } } = location;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col w-full">
            <div className="border-b border-neutral-100 pb-6 mb-6 md:mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                    Check Your Email
                </h1>
            </div>
            <div className="flex flex-col gap-2 mb-6 md:mb-8">
                <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px]">
                    An email with a password reset link will be sent to <span className="font-bold">{email}</span> if there is a matching account in Sunbound.
                </p>
                <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px]">
                    Your password reset link will be active for one hour once it has been delivered.
                </p>
            </div>
            <Button
                variant="primary"
                size="lg"
                className="w-full"
                onClick={() => navigate(`/login`)}
            >
                Back to Login
            </Button>
        </div>
    );
};


export default ForgotPasswordInfo;
